// @ts-nocheck
import React, { lazy } from 'react';
import { Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const SplitItemDialogContent = lazy(() => import('./SplitItemDialogContent'));

function SplitItemDialog({ dialogName, payload = {}, isOpen }) {
  return (
    <Dialog
      name={dialogName}
      className="dialog--split-item"
      isOpen={isOpen}
      autoFocus
      canEscapeKeyClose
      style={{ width: '420px' }}
    >
      <DialogSuspense>
        <SplitItemDialogContent
          dialogName={dialogName}
          lineItem={payload.lineItem ?? null}
          onAssign={payload.onAssign ?? null}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(SplitItemDialog);
